export default "__VITE_ASSET__uQSzHJzD__"